import { render, staticRenderFns } from "./Dynamic.vue?vue&type=template&id=df1d5fb4&scoped=true"
import script from "./Dynamic.vue?vue&type=script&lang=js"
export * from "./Dynamic.vue?vue&type=script&lang=js"
import style0 from "./Dynamic.vue?vue&type=style&index=0&id=df1d5fb4&prod&scoped=true&lang=css"
import style1 from "./Dynamic.vue?vue&type=style&index=1&id=df1d5fb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1d5fb4",
  null
  
)

export default component.exports